// removed by extract-text-webpack-plugin
module.exports = {"root":"tutorialPost-module_root_1PNAO","img":"tutorialPost-module_img_2wVGf","title":"tutorialPost-module_title_3PU42","description":"tutorialPost-module_description_1yT3P"};


//////////////////
// WEBPACK FOOTER
// ./client/pages/home/tutorialPost/tutorialPost.module.css
// module id = 486
// module chunks = 1 3